import moment from 'moment';
import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import language from '../../assets/languages/language';
import { _getProfile } from '../../common/function';
import Loader from '../../common/loader';
import { showFailure, showSuccess } from '../../common/toast';
import FD from '../RestAPI/fetchData';
import App_data from '../config/App_data';

/* eslint-disable*/
class RecurringPlanDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: '',
      idname: '',
      subscriptionList: [],
      isLoading: true,
      isCancelSubscription: false,
      currentDate: new Date(),
    };
    this.packageId = '';
    this.subscriptionId = '';
    this.subscriptionScheduleId = '';
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };
  componentDidMount() {
    window.scroll(0, 0);
    this.props.params ? this.setState({ username: this.props.params.username }) : null;
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    this.getPackages(data);
  }
  cancelSubscriptionToggle = async (packageId, subscriptionId, subscriptionScheduleId) => {
    if (packageId) {
      this.setState({
        isCancelSubscription: !this.state.isCancelSubscription,
      });
      this.packageId = packageId;
      this.subscriptionId = subscriptionId;
      this.subscriptionScheduleId = subscriptionScheduleId;
    } else {
      this.setState({ isCancelSubscription: !this.state.isCancelSubscription });
    }
  };
  getPackages = async data => {
    const result = await FD.callAPI(
      App_data.backend_api + '/user/get-recurring-plan-details',
      data,
    );

    // The route now returns a resolved `subscriptions` array (exam_name,
    // package_type and payment_interval joined from the catalogue) instead of
    // the raw users row for the client to parse.
    if (result && result.success && Array.isArray(result.subscriptions)) {
      this.setState({
        subscriptionList: result.subscriptions,
        currentDate: result.currentDate,
      });
    }
    this.setState({
      isLoading: false,
    });
  };
  cancelSubscription = async () => {
    const { token, idname } = this.state;
    const { packageId: package_id } = this;

    // Only package_id is sent now — the backend resolves the Stripe id from
    // the caller's own subscription_details. Previously it cancelled whatever
    // subscriptionId the client supplied.
    FD.callAPI(`${App_data.backend_api}/checkout_v1/cancelSubscription`, {
      token,
      idname,
      package_id,
    }).then(resp => {
      if (resp.success) {
        const { token, idname } = this.state;
        const data = {
          token,
          idname,
        };
        this.setState(
          {
            isCancelSubscription: false,
            packageId: '',
            subscriptionId: '',
          },
          () => {
            showSuccess(
              resp.accessUntil
                ? 'Cancelled. You keep access until ' + moment(resp.accessUntil).format('ll')
                : 'Your subscription has been cancelled',
            );
            this.getPackages({ token, idname });
          },
        );
      } else {
        this.setState(
          {
            isCancelSubscription: false,
            packageId: '',
            subscriptionId: '',
          },
          () => {
            showFailure((resp && resp.message) || 'Something went wrong');
          },
        );
      }
    });
  };

  render() {
    const { subscriptionList = [], currentDate } = this.state;
    let subscriptionDetails = (
      <td className='text-center pt-3' colSpan='7' contentEditable='false'>
        <b>No Subscription Plan Available.</b>
      </td>
    );

    let count = 1;
    if (subscriptionList.length) {
      // No `monthly_payment` gate here any more: /get-recurring-plan-details
      // returns recurring subscriptions ONLY, so re-filtering on a field the
      // route no longer sends rendered an empty table.
      subscriptionDetails = subscriptionList.map((tableValues, index) => {
          return (
            <tbody key={index}>
              <tr key={index}>
                <td>{count++}</td>
                <td className='exam-name'>
                  {tableValues.exam_name || tableValues.package_type || '-'}
                </td>
                <td>{tableValues.package_type}</td>
                <td>
                  <b>
                    {tableValues.amount === null || tableValues.amount === undefined
                      ? '\u2014'
                      : '$' + tableValues.amount}
                    {tableValues.amount !== null &&
                    tableValues.amount !== undefined &&
                    tableValues.payment_interval
                      ? '/' + tableValues.payment_interval
                      : ''}
                  </b>
                </td>
                <td>
                  {tableValues.expiryDate
                    ? moment(tableValues.expiryDate).format('ll')
                    : '—'}
                </td>

                <td>
                  {tableValues.status === 'expired' ? (
                    <div className='text-danger'>{language.LC().EXPIRED}</div>
                  ) : tableValues.status === 'cancelling' ? (
                    <div className='text-warning'>{'Cancelled'}</div>
                  ) : tableValues.status === 'past_due' ? (
                    <div className='text-danger'>{'Payment failed'}</div>
                  ) : (
                    'Active'
                  )}
                </td>
                <td className='text-center'>
                  {tableValues.subscriptionId || tableValues.subscriptionScheduleId ? (
                    <button
                      type='button'
                      className='btn custom-btn-danger pointer_class'
                      onClick={() =>
                        // this.cancelSubscription(tableValues.packageId, tableValues.subscriptionId)
                        this.cancelSubscriptionToggle(
                          tableValues.package_id,
                          tableValues.subscriptionId,
                          tableValues.subscriptionScheduleId,
                        )
                      }
                      disabled={tableValues.cancelledSubscription}
                    >
                      {tableValues.cancelledSubscription ? 'Cancelled' : 'Cancel Subscription'}
                    </button>
                  ) : (
                    '-'
                  )}
                </td>
              </tr>
            </tbody>
          );
      });
    }

    return (
      <div className='animated fadeIn'>
        <div className='card height_70vh'>
          <div className='card-header subscription-header d-flex align-items-center justify-content-between'>
            <div className='mb-1 d-inline-block'>{language.LC().RECURRING_SUBSCRIPTION_DETAIL}</div>
            <div className='card-actions float-md-right'>
              <button
                type='button'
                className='btn btn-primary pointer_class mb-0'
                onClick={_getProfile.bind(this, this.state.username)}
              >
                {' '}
                {language.LC().GO_TO_PROFILE}{' '}
              </button>
            </div>
          </div>
          {this.state.isLoading ? (
            <Loader />
          ) : (
            <div id='table_responsive_wrapper'>
              <div className='table-responsive order_his_tb'>
                <table className='cart_table table'>
                  <thead>
                    <tr>
                      <th>{language.LC().ID}</th>
                      <th>{language.LC().EXAM_NAME}</th>
                      <th>{language.LC().PACKAGE}</th>
                      <th>{language.LC().AMOUNT}</th>
                      {/* Covers both meanings: a live subscription renews on
                          this date, a cancelled one runs out on it. The old
                          "Renewal Date" label was wrong for every cancelled
                          row — and those are the majority on this page. */}
                      <th>{'Renewal / Access Until'}</th>
                      <th>{language.LC().STATUS}</th>
                      <th className='text-center'>{language.LC().ACTION}</th>
                    </tr>
                  </thead>
                  {subscriptionDetails}
                </table>
              </div>
            </div>
          )}
        </div>

        <Modal
          isOpen={this.state.isCancelSubscription}
          toggle={this.cancelSubscriptionToggle}
          className={'modal-primary ' + this.props.className}
        >
          <ModalHeader>
            Cancel subscription
            <Button className='close' color='secondary' onClick={this.cancelSubscriptionToggle}>
              ×
            </Button>
          </ModalHeader>
          <ModalBody>
            <div className='text-center cancel_sub'>
              <p className='margin_bottom_20'>
                <strong>{'Are you sure you want to cancel your subscription?'}</strong>
              </p>
              <p className='margin_bottom_20'>
                {'You will keep access until the end of the period you have already paid for.'}
              </p>

              <div className='d-flex justify-content-center flex-small-wrap' style={{ gap: '10px' }}>
                <Button
                  className='btn btn-sm btn-primary'
                  color='primary'
                  onClick={() => this.cancelSubscriptionToggle()}
                >
                  {'Keep subscription'}
                </Button>
                <Button
                  className='btn btn-sm btn-danger'
                  color='danger'
                  onClick={this.cancelSubscription}
                >
                  {'Yes, cancel'}
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default RecurringPlanDetail;



// WEBPACK FOOTER //
// ./src/views/SubscriptionDetail/RecurringPlanDetail.js